import React, { Component, Fragment } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { toast } from 'react-toastify';
import { connect } from 'react-redux'
import * as Yup from "yup";
import axios from "axios";

import { withRouter } from 'react-router-dom'

import { userLogin } from '../../../redux/auth/actions';

const SignupSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email")
    .required("Required"),
  nom: Yup.string()
    .required("Required"),
  prenom: Yup.string()
    .required("Required"),
  accept: Yup.boolean().oneOf([true]).required('Required')
  
});


class SignupForm extends Component {
    render() {
      return (
        <Fragment>
        { this.props.termes.mailsubscribeapp.signupparamTextIntro && this.props.termes.mailsubscribeapp.signupparamTextIntro!='signupparamTextIntro' ? <div><p>{ this.props.termes.mailsubscribeapp.signupparamTextIntro}</p></div>:null}
        <Formik
        initialValues={{ email: '', nom:'', prenom: '', societe:'', rue:'', cp:'', localite:'', pays:'', tel:'', accept:false }}
        validationSchema={SignupSchema}
        onSubmit={(values, { setSubmitting }) => {
              axios
                .post("auth/signup", {
                  email: values.email,
                  nom: values.nom,
                  prenom: values.prenom,
                  societe: values.societe,
                  rue: values.rue,
                  cp: values.cp,
                  localite: values.localite,
                  pays: values.pays,
                  tel: values.tel
                })
                .then(res => {
                  if(res.data){
                    if(res.data.error){
                      toast.error(res.data.error);
                    }else{
                      this.props.userLogin(res.data);
                      this.props.history.push('/dashboard');
                    }
                  }
                  setSubmitting(false);
                }).catch(error => {  toast.error(error.message);setSubmitting(false); });
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <label htmlFor="email">{ this.props.termes.mailsubscribeapp.signupparamLabelEmail}</label>
            <Field type="email" name="email" />
            <ErrorMessage name="email"  className="error" component="div" />
            <label htmlFor="nom">{ this.props.termes.mailsubscribeapp.signupparamLabelNom}</label>
            <Field type="text" name="nom" />
            <ErrorMessage name="nom"  className="error" component="div" />
            <label htmlFor="prenom">{ this.props.termes.mailsubscribeapp.signupparamLabelPrenom}</label>
            <Field type="text" name="prenom" />
            <ErrorMessage name="prenom" className="error" component="div" />
            <label htmlFor="societe">{ this.props.termes.mailsubscribeapp.signupparamLabelSociete}</label>
            <Field type="text" name="societe" />
            <ErrorMessage name="societe" className="error" component="div" />
            <label htmlFor="rue">{ this.props.termes.mailsubscribeapp.signupparamLabelRue}</label>
            <Field type="text" name="rue" />
            <ErrorMessage name="rue" className="error" component="div" />
            <label htmlFor="cp">{ this.props.termes.mailsubscribeapp.signupparamLabelCP}</label>
            <Field type="text" name="cp" />
            <ErrorMessage name="cp" className="error" component="div" />
            <label htmlFor="localite">{ this.props.termes.mailsubscribeapp.signupparamLabelVille}</label>
            <Field type="text" name="localite" />
            <ErrorMessage name="localite" className="error" component="div" />
            <label htmlFor="pays">{ this.props.termes.mailsubscribeapp.signupparamLabelPays}</label>
            <Field type="text" name="pays" />
            <ErrorMessage name="pays" className="error" component="div" />
            <label htmlFor="tel">{ this.props.termes.mailsubscribeapp.signupparamLabelTel}</label>
            <Field type="text" name="tel" />
            <ErrorMessage name="tel" className="error" component="div" />
            <label><Field type="checkbox" name="accept" />  { this.props.termes.mailsubscribeapp.signupparamLabelAccept} (<a href="https://researchjewel.com/en/gsc" target="_blank">View</a>)</label>
            <ErrorMessage name="accept" className="error" component="div" />
            <button type="submit" disabled={isSubmitting}>
              { this.props.termes.mailsubscribeapp.signupparamBTNSubscribe}
            </button>
          </Form>
        )}
    </Formik>
    </Fragment>
      );
    }
}

const mapStateToProps = (state)=>{
  return {
    token: state.auth.token,
    userinfos: state.auth.userinfos,
    termes: state.settings.termes
  }
};


export default connect(mapStateToProps, {userLogin})(withRouter(SignupForm));